// Generated by generateKotlinApi; do not edit.
package io.github.erkko68.kolt.physics.collision

import io.github.erkko68.kolt.*
import io.github.erkko68.kolt.capi.*
import io.github.erkko68.kolt.core.*
import io.github.erkko68.kolt.core.capi.*
import io.github.erkko68.kolt.geometry.*
import io.github.erkko68.kolt.geometry.capi.*
import io.github.erkko68.kolt.interop.*
import io.github.erkko68.kolt.math.*
import io.github.erkko68.kolt.objectstream.*
import io.github.erkko68.kolt.physics.*
import io.github.erkko68.kolt.physics.body.*
import io.github.erkko68.kolt.physics.body.capi.*
import io.github.erkko68.kolt.physics.capi.*
import io.github.erkko68.kolt.physics.character.*
import io.github.erkko68.kolt.physics.character.capi.*
import io.github.erkko68.kolt.physics.collision.broadphase.*
import io.github.erkko68.kolt.physics.collision.broadphase.capi.*
import io.github.erkko68.kolt.physics.collision.capi.*
import io.github.erkko68.kolt.physics.collision.shape.*
import io.github.erkko68.kolt.physics.collision.shape.capi.*
import io.github.erkko68.kolt.physics.constraints.*
import io.github.erkko68.kolt.physics.constraints.capi.*
import io.github.erkko68.kolt.physics.constraints.constraintpart.*
import io.github.erkko68.kolt.physics.ragdoll.*
import io.github.erkko68.kolt.physics.ragdoll.capi.*
import io.github.erkko68.kolt.physics.softbody.*
import io.github.erkko68.kolt.physics.softbody.capi.*
import io.github.erkko68.kolt.physics.vehicle.*
import io.github.erkko68.kolt.physics.vehicle.capi.*
import io.github.erkko68.kolt.skeleton.*
import io.github.erkko68.kolt.skeleton.capi.*

/** C++ `JPH::RRayCast`. */
class RRayCast internal constructor(internal val rRayCastHandle: NativePointer, owned: Boolean = false) : NativeObject(owned), AutoCloseable {
    constructor(ray: RayCast) : this(JphRRayCast_create_RayCast(ray.rayCastHandle), owned = true)
    constructor() : this(JphRRayCast_create(), owned = true)
    constructor(arg0: Vec3, arg1: Vec3) : this(interopScope { JphRRayCast_create_ArgType_Vec3Arg(toInterop(arg0.toArray()), toInterop(arg1.toArray())) }, owned = true)

    override fun close() =
        closeOnce { JphRRayCast_destroy(rRayCastHandle) }
}
